//Import Libraries
import React, { useEffect, useState, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { updateAlert, updateSourceInputs } from "../../../../redux/actions";
import { config } from "../../../../config/config";
import AdminView from "../AdminView";
import { useUserAuthentication } from "../../../../utils/utils";
import Loader from "../../../../components/Loader/Loader";
import Filters from "../components/Filters";
import TableView from "../components/TableView";

let api = config.api.api_url;

function RolesView(props) {
  const { user, userData, source_data, updateAlert, updateSourceInputs } =
    props || {};
  const { login } = useUserAuthentication();
  const [loading, setLoading] = useState(false);
  const [viewFullRowRecord, setViewFullRecord] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isRowDataUpdating, setIsRowDataUpdating] = useState(false);

  const DROPDOWN_DATA = source_data?.data?.dropdown || {};
  const TABLE_HEADER_COLUMN = DROPDOWN_DATA?.table_header_column_list || [];
  const Edit_Column_Module = DROPDOWN_DATA?.edit_column_model_list || [];

  const fetchAllUsers = async () => {
    setLoading(true);
    const params = new URLSearchParams({
      dataset_name: "roles_admin",
    });
    try {
      const response = await fetch(api + `/admin/getallroles?${params}`, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Authorization: `Bearer ${user.token || ""}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });

          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }
      let ItemId = 0;
      const ROLE_LIST =
        data?.data?.map((user) => {
          return {
            item_Id: ItemId++,
            isNewData: false,
            isEdited: false,
            isEditing: false,
            isDeleted: false,
            rowData: user,
          };
        }) ?? [];
      updateSourceInputs("current_mapped_data", ROLE_LIST);
      const DATA = {
        data: data?.metadata || [],
        dropdown: {
          ...(data?.metadata || {}),
        },
      };
      updateSourceInputs("data", DATA);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "success",
        closeFlag: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleEditRow = () => {};

  const handleDeleteRow = async (deleteData) => {
    try {
      const params = new URLSearchParams({
        roleid: deleteData?._id || "",
      });
      const response = await fetch(api + `/admin/deleterole?${params}`, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Authorization: `Bearer ${user.token || ""}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });

          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      updateAlert({
        open: true,
        message: "RowData has been Deleted successfully",
        severity: "info",
        closeFlag: true,
      });
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "success",
        closeFlag: true,
      });
    } finally {
      setIsDeleteDialogOpen(false);
    }
  };

  const handleUpdateRow = async (editrecord) => {
    try {
      const params = new URLSearchParams({
        roleid: editrecord?._id || "",
      });
      const response = await fetch(api + `/admin/updaterole?${params}`, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: {
          Authorization: `Bearer ${user.token || ""}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editrecord ?? {}),
      });

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });

          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      updateAlert({
        open: true,
        message: "RowData has been updated successfully",
        severity: "info",
        closeFlag: true,
      });
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "success",
        closeFlag: true,
      });
    } finally {
      setIsRowDataUpdating(false);
    }
  };

  const handleCreateNewRow = async (editrecord) => {
    try {
      const params = new URLSearchParams({
        roleid: "GTM_ADMIN",
      });

      const response = await fetch(api + `/admin/createnewrole?${params}`, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: {
          Authorization: `Bearer ${user.token || ""}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editrecord ?? {}),
      });

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });

          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      updateAlert({
        open: true,
        message: "RowData has been updated successfully",
        severity: "info",
        closeFlag: true,
      });
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "success",
        closeFlag: true,
      });
    } finally {
      setIsRowDataUpdating(false);
    }
  };

  useEffect(() => {
    fetchAllUsers();
  }, []);

  return (
    <AdminView>
      {loading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          <Loader />
          Loading Role details...
        </div>
      ) : (
        <div style={{ padding: "8px" }}>
          <TableView
            TableData={source_data?.current_mapped_data || []}
            handleDeleteRow={handleDeleteRow}
            handleEditRow={handleEditRow}
            isDeleteDialogOpen={isDeleteDialogOpen}
            setIsDeleteDialogOpen={setIsDeleteDialogOpen}
            isRowDataUpdating={isRowDataUpdating}
            viewFullRowRecord={viewFullRowRecord}
            setViewFullRecord={setViewFullRecord}
            setIsRowDataUpdating={setIsRowDataUpdating}
            tableHeadColumns={TABLE_HEADER_COLUMN}
            editModelColumnList={Edit_Column_Module}
            usecase={"roles"}
            usecaseLabel={"Role"}
            handleUpdateRow={handleUpdateRow}
            handleCreateNewRow={handleCreateNewRow}
          >
            <button>+ Add new role</button>
          </TableView>
        </div>
      )}
    </AdminView>
  );
}

RolesView.propTypes = {
  user: PropTypes.object,
  userData: PropTypes.object,
  source_data: PropTypes.object,
  updateAlert: PropTypes.func,
  updateSourceInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  user: state.user,
  // userData:state.cncStateData.user,
  cncData: state.cncinputs,
  source_data: state.source,
});

const mapDispatchToProps = {
  updateAlert,
  updateSourceInputs,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RolesView),
);
